// import React, { useState, useEffect, useRef, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   FaCalendarAlt,
//   FaCheck,
//   FaChevronDown,
//   FaExchangeAlt,
//   FaMapMarkerAlt,
//   FaPlaneArrival,
//   FaPlaneDeparture,
//   FaSearch,
//   FaSpinner,
// } from "react-icons/fa";
// import heroImage from "../../assets/react-flights-hero-bg.jpg";

// const getFormattedDate = (dateObj) => {
//   const year = dateObj.getFullYear();
//   const month = String(dateObj.getMonth() + 1).padStart(2, "0");
//   const day = String(dateObj.getDate()).padStart(2, "0");
//   return `${year}-${month}-${day}`;
// };

// const fieldShell =
//   "group relative flex min-h-[76px] flex-col justify-center rounded-[1.25rem] border border-slate-200 bg-white px-4 py-3 shadow-sm transition-all duration-200 hover:border-blue-200 hover:shadow-md focus-within:border-[#2871d3] focus-within:ring-4 focus-within:ring-blue-100";

// const fieldLabel =
//   "mb-1 flex items-center gap-2 text-[0.68rem] font-black uppercase tracking-[0.16em] text-slate-400";

// const inputClass =
//   "w-full min-w-0 bg-transparent text-[1.05rem] font-extrabold text-slate-950 outline-none placeholder:font-semibold placeholder:text-slate-300 sm:text-lg";

// const FlightSearchWidget = () => {
//   const navigate = useNavigate();

//   const today = new Date();
//   const tomorrow = new Date(today);
//   tomorrow.setDate(tomorrow.getDate() + 1);

//   const todayStr = getFormattedDate(today);
//   const tomorrowStr = getFormattedDate(tomorrow);

//   const [tripType, setTripType] = useState("return");
//   const [departDate, setDepartDate] = useState(todayStr);
//   const [returnDate, setReturnDate] = useState(tomorrowStr);
//   const [cabinClass, setCabinClass] = useState("economy");
//   const [directOnly, setDirectOnly] = useState(false);

//   const [originQuery, setOriginQuery] = useState("");
//   const [originSelected, setOriginSelected] = useState({
//     name: "",
//     iata_code: "",
//     id: "",
//   });

//   const [destQuery, setDestQuery] = useState("");
//   const [destSelected, setDestSelected] = useState({
//     name: "",
//     iata_code: "",
//     id: "",
//   });

//   const [originResults, setOriginResults] = useState([]);
//   const [showOriginDropdown, setShowOriginDropdown] = useState(false);
//   const [loadingOrigin, setLoadingOrigin] = useState(false);

//   const [destResults, setDestResults] = useState([]);
//   const [showDestDropdown, setShowDestDropdown] = useState(false);
//   const [loadingDest, setLoadingDest] = useState(false);

//   const originRef = useRef(null);
//   const destRef = useRef(null);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (originRef.current && !originRef.current.contains(event.target)) {
//         setShowOriginDropdown(false);
//       }
//       if (destRef.current && !destRef.current.contains(event.target)) {
//         setShowDestDropdown(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const fetchSuggestions = useCallback(
//     async (query, setResults, setLoading) => {
//       if (!query || query.trim().length < 2) return setResults([]);
//       if (
//         originSelected &&
//         query === `${originSelected.name} (${originSelected.iata_code})`
//       ) {
//         return;
//       }
//       if (
//         destSelected &&
//         query === `${destSelected.name} (${destSelected.iata_code})`
//       ) {
//         return;
//       }

//       setLoading(true);
//       try {
//         const response = await fetch(
//           `https://cheapoflyhub-api.mohitbajaj1995.workers.dev/places/search?query=${encodeURIComponent(
//             query,
//           )}`,
//         );
//         if (!response.ok) throw new Error(`HTTP ${response.status}`);
//         const data = await response.json();
//         setResults(data.data || []);
//       } catch (error) {
//         console.error("Error fetching suggestions:", error);
//         setResults([]);
//       } finally {
//         setLoading(false);
//       }
//     },
//     [destSelected, originSelected],
//   );

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (showOriginDropdown && originQuery.length >= 2) {
//         fetchSuggestions(originQuery, setOriginResults, setLoadingOrigin);
//       }
//     }, 300);
//     return () => clearTimeout(timer);
//   }, [fetchSuggestions, originQuery, showOriginDropdown]);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (showDestDropdown && destQuery.length >= 2) {
//         fetchSuggestions(destQuery, setDestResults, setLoadingDest);
//       }
//     }, 300);
//     return () => clearTimeout(timer);
//   }, [destQuery, fetchSuggestions, showDestDropdown]);

//   const handleSwap = () => {
//     const tempQuery = originQuery;
//     const tempSelected = originSelected;
//     setOriginQuery(destQuery);
//     setOriginSelected(destSelected);
//     setDestQuery(tempQuery);
//     setDestSelected(tempSelected);
//   };

//   const handleSelectPlace = (place, isOrigin) => {
//     const displayValue = `${place.name} (${place.iata_code})`;
//     if (isOrigin) {
//       setOriginQuery(displayValue);
//       setOriginSelected(place);
//       setShowOriginDropdown(false);
//     } else {
//       setDestQuery(displayValue);
//       setDestSelected(place);
//       setShowDestDropdown(false);
//     }
//   };

//   const handleDepartDateChange = (e) => {
//     const newDepartDate = e.target.value;
//     setDepartDate(newDepartDate);

//     if (returnDate <= newDepartDate) {
//       const nextDay = new Date(newDepartDate);
//       nextDay.setDate(nextDay.getDate() + 1);
//       setReturnDate(getFormattedDate(nextDay));
//     }
//   };

//   const handleSearchFlights = () => {
//     if (!originSelected || !destSelected) {
//       alert("Please select valid origin and destination airports.");
//       return;
//     }

//     const params = new URLSearchParams({
//       tripType,
//       origin: originSelected.iata_code,
//       originName: originSelected.name,
//       dest: destSelected.iata_code,
//       destName: destSelected.name,
//       departDate,
//       returnDate: tripType === "return" ? returnDate : "",
//       cabinClass,
//       directOnly: directOnly.toString(),
//     });

//     navigate(`/flights?${params.toString()}`);
//   };

//   const renderDropdownList = (results, isLoading, isOrigin) => {
//     if (isLoading) {
//       return (
//         <div className="flex items-center justify-center gap-3 p-6 text-sm font-semibold text-slate-500">
//           <FaSpinner className="h-4 w-4 animate-spin text-[#2871d3]" />
//           Searching places...
//         </div>
//       );
//     }

//     if (!results || results.length === 0) {
//       return (
//         <div className="bg-slate-50/80 p-6 text-center text-sm font-medium text-slate-500">
//           No destinations found. Try another city or code.
//         </div>
//       );
//     }

//     return (
//       <div className="max-h-72 overflow-y-auto divide-y divide-slate-100">
//         {results.map((item) => (
//           <button
//             key={item.id}
//             type="button"
//             onClick={() => handleSelectPlace(item, isOrigin)}
//             className="group flex w-full items-center justify-between gap-4 px-4 py-3 text-left transition-colors hover:bg-blue-50 sm:px-5"
//           >
//             <div className="min-w-0">
//               <div className="mb-1 flex min-w-0 items-center gap-2">
//                 <span className="shrink-0 rounded-full bg-blue-100 px-2 py-0.5 text-[0.62rem] font-black uppercase tracking-wide text-[#2871d3]">
//                   {item.type}
//                 </span>
//                 <span className="truncate text-sm font-extrabold text-slate-950">
//                   {item.name}
//                 </span>
//               </div>
//               {item.city_name && (
//                 <div className="flex items-center gap-1.5 truncate text-xs font-medium text-slate-500">
//                   <FaMapMarkerAlt className="h-3 w-3 shrink-0 text-slate-300" />
//                   <span className="truncate">
//                     {item.city_name}, {item.country_code}
//                   </span>
//                 </div>
//               )}
//             </div>
//             <span className="shrink-0 rounded-xl bg-slate-100 px-2.5 py-1 font-mono text-sm font-black text-slate-500 transition-colors group-hover:bg-[#2871d3] group-hover:text-white">
//               {item.iata_code}
//             </span>
//           </button>
//         ))}
//       </div>
//     );
//   };

//   const PlaceDropdown = ({ show, results, loading, isOrigin }) =>
//     show ? (
//       <div className="absolute left-0 right-0 top-[calc(100%+10px)] z-[80] overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-2xl shadow-slate-900/15 ring-1 ring-slate-900/5">
//         {renderDropdownList(results, loading, isOrigin)}
//       </div>
//     ) : null;

//   return (
//     <section className="relative z-30 isolate overflow-visible bg-white font-sans">
//       <div className="absolute inset-0 -z-10">
//         <img
//           src={heroImage}
//           alt="Airplane wing over a bright sky"
//           className="h-full w-full object-cover"
//         />
//         <div className="absolute inset-0 bg-gradient-to-b from-white/15 via-white/45 to-white" />
//       </div>

//       <div className="mx-auto flex min-h-[660px] w-full max-w-7xl items-end px-3 pb-8 pt-20 sm:min-h-[650px] sm:px-5 sm:pb-12 lg:min-h-[700px] lg:px-8">
//         <div className="w-full">
//           <div className="mb-6 max-w-3xl px-1 text-slate-950 sm:mb-8">
//             <p className="mb-3 inline-flex rounded-full bg-white/90 px-4 py-2 text-xs font-black uppercase tracking-[0.18em] text-[#2871d3] shadow-sm ring-1 ring-slate-200">
//               Flight booking Platform
//             </p>
//             <h1 className="max-w-3xl text-4xl font-black leading-tight sm:text-5xl lg:text-7xl">
//               Book your next flight with confidence.
//             </h1>
//             <p className="mt-4 max-w-2xl text-base font-medium leading-7 text-slate-600 sm:text-lg">
//               Compare fares, choose flexible routes, and get real support for
//               every trip.
//             </p>
//           </div>

//           <div className="rounded-[1.7rem] border border-slate-200 bg-white/95 p-3 shadow-[0_24px_70px_rgba(15,23,42,0.16)] backdrop-blur-xl sm:rounded-[2rem] sm:p-5 lg:p-6">
//             <div className="mb-4 flex flex-col gap-3 sm:mb-5 sm:flex-row sm:items-center sm:justify-between">
//               <div className="grid w-full grid-cols-2 rounded-full bg-[#f8f9fc] p-1 sm:w-auto">
//                 {[
//                   { label: "Return", value: "return" },
//                   { label: "One-way", value: "oneway" },
//                 ].map((item) => (
//                   <button
//                     key={item.value}
//                     type="button"
//                     onClick={() => setTripType(item.value)}
//                     className={`min-h-11 rounded-full px-4 text-sm font-black transition-all duration-200 ${
//                       tripType === item.value
//                         ? "bg-[#2871d3] text-white shadow-sm shadow-blue-600/20"
//                         : "text-slate-500 hover:text-slate-950"
//                     }`}
//                   >
//                     {item.label}
//                   </button>
//                 ))}
//               </div>

//               <label className="flex min-h-11 cursor-pointer items-center justify-between gap-3 rounded-full border border-slate-200 bg-white px-4 text-sm font-extrabold text-slate-700 shadow-sm transition hover:border-blue-200 hover:text-slate-950 sm:justify-start">
//                 <span>Direct flights only</span>
//                 <span className="relative flex h-6 w-6 shrink-0 items-center justify-center">
//                   <input
//                     type="checkbox"
//                     checked={directOnly}
//                     onChange={(e) => setDirectOnly(e.target.checked)}
//                     className="peer h-6 w-6 cursor-pointer appearance-none rounded-lg border-2 border-slate-300 bg-white transition checked:border-[#2871d3] checked:bg-[#2871d3] focus:outline-none focus:ring-4 focus:ring-blue-100"
//                   />
//                   <FaCheck className="pointer-events-none absolute h-3 w-3 text-white opacity-0 transition peer-checked:opacity-100" />
//                 </span>
//               </label>
//             </div>

//             <div className="grid grid-cols-1 gap-3 lg:grid-cols-12 lg:gap-4">
//               <div className="relative grid grid-cols-1 gap-3 sm:grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] lg:col-span-6">
//                 <div className="relative" ref={originRef}>
//                   <div className={fieldShell}>
//                     <label className={fieldLabel}>
//                       <FaPlaneDeparture className="text-[#2871d3]" />
//                       Leaving From
//                     </label>
//                     <input
//                       type="text"
//                       value={originQuery}
//                       onChange={(e) => setOriginQuery(e.target.value)}
//                       onFocus={() => setShowOriginDropdown(true)}
//                       placeholder="City or Airport"
//                       className={`${inputClass} truncate`}
//                     />
//                   </div>
//                   <PlaceDropdown
//                     show={showOriginDropdown}
//                     results={originResults}
//                     loading={loadingOrigin}
//                     isOrigin
//                   />
//                 </div>

//                 <div className="hidden md:flex justify-center items-center">
//                   <button
//                     type="button"
//                     onClick={handleSwap}
//                     aria-label="Swap origin and destination"
//                     className="z-20 -my-1 flex h-11 w-11 items-center justify-center rounded-full border border-slate-200 bg-white text-[#2871d3] shadow-lg shadow-slate-900/10 transition hover:border-blue-200 hover:bg-blue-50 active:scale-95 sm:my-0"
//                   >
//                     <FaExchangeAlt className="h-4 w-4 rotate-90 sm:rotate-0" />
//                   </button>
//                 </div>

//                 <div className="relative" ref={destRef}>
//                   <div className={fieldShell}>
//                     <label className={fieldLabel}>
//                       <FaPlaneArrival className="text-[#2871d3]" />
//                       Going To
//                     </label>
//                     <input
//                       type="text"
//                       value={destQuery}
//                       onChange={(e) => setDestQuery(e.target.value)}
//                       onFocus={() => setShowDestDropdown(true)}
//                       placeholder="City or Airport"
//                       className={`${inputClass} truncate`}
//                     />
//                   </div>
//                   <PlaceDropdown
//                     show={showDestDropdown}
//                     results={destResults}
//                     loading={loadingDest}
//                     isOrigin={false}
//                   />
//                 </div>
//               </div>

//               <div className="grid grid-cols-1 gap-3 min-[420px]:grid-cols-2 lg:col-span-3 lg:gap-4">
//                 <div className={fieldShell}>
//                   <label className={fieldLabel}>
//                     <FaCalendarAlt className="text-[#2871d3]" />
//                     Depart
//                   </label>
//                   <input
//                     type="date"
//                     min={todayStr}
//                     value={departDate}
//                     onChange={handleDepartDateChange}
//                     className="w-full bg-transparent text-base font-extrabold text-slate-950 outline-none [color-scheme:light]"
//                   />
//                 </div>

//                 <div
//                   className={`${fieldShell} ${
//                     tripType === "oneway"
//                       ? "border-slate-100 bg-slate-50 opacity-70"
//                       : ""
//                   }`}
//                 >
//                   <label className={fieldLabel}>
//                     <FaCalendarAlt className="text-[#2871d3]" />
//                     Return
//                   </label>
//                   <input
//                     type="date"
//                     min={departDate}
//                     disabled={tripType === "oneway"}
//                     value={tripType === "oneway" ? "" : returnDate}
//                     onChange={(e) => setReturnDate(e.target.value)}
//                     className="w-full bg-transparent text-base font-extrabold text-slate-950 outline-none disabled:cursor-not-allowed [color-scheme:light]"
//                   />
//                 </div>
//               </div>

//               <div className="grid grid-cols-1 gap-3 min-[420px]:grid-cols-[minmax(0,1fr)_auto] lg:col-span-3 lg:grid-cols-[minmax(0,1fr)_minmax(128px,0.8fr)] lg:gap-4">
//                 <div className={fieldShell}>
//                   <label className={fieldLabel}>
//                     <FaChevronDown className="text-[#2871d3]" />
//                     Class
//                   </label>
//                   <select
//                     value={cabinClass}
//                     onChange={(e) => setCabinClass(e.target.value)}
//                     className="w-full min-w-0 appearance-none truncate bg-transparent text-base font-extrabold text-slate-950 outline-none"
//                   >
//                     <option value="economy">Economy</option>
//                     <option value="premium_economy">Premium Economy</option>
//                     <option value="business">Business</option>
//                     <option value="first">First Class</option>
//                   </select>
//                 </div>

//                 <button
//                   type="button"
//                   onClick={handleSearchFlights}
//                   className="flex min-h-[76px] w-full items-center justify-center gap-3 rounded-[1.25rem] bg-[#2871d3] px-6 text-base font-black text-white shadow-xl shadow-blue-600/20 transition hover:-translate-y-0.5 hover:bg-[#155bc2] hover:shadow-blue-600/30 active:translate-y-0 min-[420px]:px-5"
//                 >
//                   <FaSearch className="h-4 w-4" />
//                   <span className="min-[420px]:sr-only xl:not-sr-only">
//                     Search
//                   </span>
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FlightSearchWidget;
// -------------------------

import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaCalendarAlt,
  FaCheck,
  FaChevronDown,
  FaExchangeAlt,
  FaMapMarkerAlt,
  FaPlaneArrival,
  FaPlaneDeparture,
  FaSearch,
  FaShieldAlt,
  FaSpinner,
  FaStar,
} from "react-icons/fa";
// Make sure this path matches your project structure
import heroImage from "../../assets/react-flights-hero-bg.jpg";

const getFormattedDate = (dateObj) => {
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// Sleeker, modern input shell with smooth transitions and subtle scale effects
const fieldShell =
  "group relative flex min-h-[70px] lg:min-h-[76px] flex-col justify-center rounded-2xl md:rounded-[1.25rem] border border-white/60 bg-white/80 px-4 py-2 sm:py-3 shadow-sm transition-all duration-300 ease-out hover:bg-white hover:shadow-md focus-within:-translate-y-0.5 focus-within:border-[#2871d3] focus-within:bg-white focus-within:shadow-lg focus-within:ring-4 focus-within:ring-[#2871d3]/10";

const fieldLabel =
  "mb-0.5 sm:mb-1 flex items-center gap-1.5 text-[0.65rem] sm:text-[0.68rem] font-black uppercase tracking-[0.15em] text-slate-500 transition-colors group-focus-within:text-[#2871d3]";

const inputClass =
  "w-full min-w-0 bg-transparent text-base sm:text-lg font-extrabold text-slate-900 outline-none placeholder:font-semibold placeholder:text-slate-400";

const trustStats = [
  ["24/7", "Live support"],
  ["500+", "Route options"],
  ["Secure", "Booking help"],
];

const popularRoutes = [
  "New York to London",
  "Los Angeles to Tokyo",
  "Miami to Dubai",
];

const FlightSearchWidget = () => {
  const navigate = useNavigate();

  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);

  const todayStr = getFormattedDate(today);
  const tomorrowStr = getFormattedDate(tomorrow);

  const [tripType, setTripType] = useState("return");
  const [departDate, setDepartDate] = useState(todayStr);
  const [returnDate, setReturnDate] = useState(tomorrowStr);
  const [cabinClass, setCabinClass] = useState("economy");
  const [directOnly, setDirectOnly] = useState(false);

  const [originQuery, setOriginQuery] = useState("");
  const [originSelected, setOriginSelected] = useState({
    name: "",
    iata_code: "",
    id: "",
  });

  const [destQuery, setDestQuery] = useState("");
  const [destSelected, setDestSelected] = useState({
    name: "",
    iata_code: "",
    id: "",
  });

  const [originResults, setOriginResults] = useState([]);
  const [showOriginDropdown, setShowOriginDropdown] = useState(false);
  const [loadingOrigin, setLoadingOrigin] = useState(false);

  const [destResults, setDestResults] = useState([]);
  const [showDestDropdown, setShowDestDropdown] = useState(false);
  const [loadingDest, setLoadingDest] = useState(false);

  const originRef = useRef(null);
  const destRef = useRef(null);

  // Close dropdowns on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (originRef.current && !originRef.current.contains(event.target)) {
        setShowOriginDropdown(false);
      }
      if (destRef.current && !destRef.current.contains(event.target)) {
        setShowDestDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Fetch logic
  const fetchSuggestions = useCallback(
    async (query, setResults, setLoading) => {
      if (!query || query.trim().length < 2) return setResults([]);
      if (
        originSelected &&
        query === `${originSelected.name} (${originSelected.iata_code})`
      )
        return;
      if (
        destSelected &&
        query === `${destSelected.name} (${destSelected.iata_code})`
      )
        return;

      setLoading(true);
      try {
        const response = await fetch(
          `https://cheapoflyhub-api.mohitbajaj1995.workers.dev/places/search?query=${encodeURIComponent(query)}`,
        );
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const data = await response.json();
        setResults(data.data || []);
      } catch (error) {
        console.error("Error fetching suggestions:", error);
        setResults([]);
      } finally {
        setLoading(false);
      }
    },
    [destSelected, originSelected],
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      if (showOriginDropdown && originQuery.length >= 2) {
        fetchSuggestions(originQuery, setOriginResults, setLoadingOrigin);
      }
    }, 300);
    return () => clearTimeout(timer);
  }, [fetchSuggestions, originQuery, showOriginDropdown]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (showDestDropdown && destQuery.length >= 2) {
        fetchSuggestions(destQuery, setDestResults, setLoadingDest);
      }
    }, 300);
    return () => clearTimeout(timer);
  }, [destQuery, fetchSuggestions, showDestDropdown]);

  const handleSwap = () => {
    const tempQuery = originQuery;
    const tempSelected = originSelected;
    setOriginQuery(destQuery);
    setOriginSelected(destSelected);
    setDestQuery(tempQuery);
    setDestSelected(tempSelected);
  };

  const handleSelectPlace = (place, isOrigin) => {
    const displayValue = `${place.name} (${place.iata_code})`;
    if (isOrigin) {
      setOriginQuery(displayValue);
      setOriginSelected(place);
      setShowOriginDropdown(false);
    } else {
      setDestQuery(displayValue);
      setDestSelected(place);
      setShowDestDropdown(false);
    }
  };

  const handleDepartDateChange = (e) => {
    const newDepartDate = e.target.value;
    setDepartDate(newDepartDate);
    if (returnDate <= newDepartDate) {
      const nextDay = new Date(newDepartDate);
      nextDay.setDate(nextDay.getDate() + 1);
      setReturnDate(getFormattedDate(nextDay));
    }
  };

  const handleSearchFlights = () => {
    if (!originSelected || !destSelected) {
      alert("Please select valid origin and destination airports.");
      return;
    }
    const params = new URLSearchParams({
      tripType,
      origin: originSelected.iata_code,
      originName: originSelected.name,
      dest: destSelected.iata_code,
      destName: destSelected.name,
      departDate,
      returnDate: tripType === "return" ? returnDate : "",
      cabinClass,
      directOnly: directOnly.toString(),
    });
    navigate(`/flights?${params.toString()}`);
  };

  const renderDropdownList = (results, isLoading, isOrigin) => {
    if (isLoading) {
      return (
        <div className="flex items-center justify-center gap-3 p-6 text-sm font-semibold text-slate-500">
          <FaSpinner className="h-4 w-4 animate-spin text-[#2871d3]" />
          Searching places...
        </div>
      );
    }
    if (!results || results.length === 0) {
      return (
        <div className="bg-slate-50/80 p-6 text-center text-sm font-medium text-slate-500">
          No destinations found. Try another city or code.
        </div>
      );
    }
    return (
      <div className="max-h-72 overflow-y-auto divide-y divide-slate-100">
        {results.map((item) => (
          <button
            key={item.id}
            type="button"
            onClick={() => handleSelectPlace(item, isOrigin)}
            className="group flex w-full items-center justify-between gap-4 px-4 py-3 text-left transition-colors hover:bg-blue-50/80 sm:px-5"
          >
            <div className="min-w-0">
              <div className="mb-1 flex min-w-0 items-center gap-2">
                <span className="shrink-0 rounded-full bg-blue-100/50 px-2 py-0.5 text-[0.62rem] font-black uppercase tracking-wide text-[#2871d3]">
                  {item.type}
                </span>
                <span className="truncate text-sm font-extrabold text-slate-900">
                  {item.name}
                </span>
              </div>
              {item.city_name && (
                <div className="flex items-center gap-1.5 truncate text-xs font-medium text-slate-500">
                  <FaMapMarkerAlt className="h-3 w-3 shrink-0 text-slate-300" />
                  <span className="truncate">
                    {item.city_name}, {item.country_code}
                  </span>
                </div>
              )}
            </div>
            <span className="shrink-0 rounded-xl bg-slate-100/80 px-2.5 py-1 font-mono text-sm font-black text-slate-500 transition-colors group-hover:bg-[#2871d3] group-hover:text-white shadow-sm">
              {item.iata_code}
            </span>
          </button>
        ))}
      </div>
    );
  };

  const PlaceDropdown = ({ show, results, loading, isOrigin }) => (
    <div
      className={`absolute left-0 right-0 top-[calc(100%+8px)] z-[80] overflow-hidden rounded-2xl border border-slate-100 bg-white/95 backdrop-blur-xl shadow-2xl shadow-slate-900/10 ring-1 ring-slate-900/5 transition-all duration-200 origin-top ${
        show
          ? "opacity-100 scale-y-100 pointer-events-auto"
          : "opacity-0 scale-y-95 pointer-events-none"
      }`}
    >
      {renderDropdownList(results, loading, isOrigin)}
    </div>
  );

  return (
    <section className="relative z-30 isolate overflow-visible bg-slate-50 font-sans">
      {/* Background Hero Layer */}
      <div className="absolute inset-0 -z-10 h-[88%] overflow-hidden lg:h-full">
        <img
          src={heroImage}
          alt="Beautiful travel destination"
          className="h-full w-full scale-105 object-cover object-center"
        />
        {/* Adjusted gradient for better text readability and modern blending */}
        <div className="absolute inset-0 bg-gradient-to-t from-slate-50 via-slate-950/30 to-slate-950/70" />
        <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(15,23,42,0.78),rgba(15,23,42,0.28),rgba(15,23,42,0.08))]" />
      </div>

      <div className="mx-auto flex min-h-[calc(100dvh-64px)] w-full max-w-[1400px] flex-col justify-end px-4 pb-10 pt-10 sm:px-6 sm:pb-14 md:min-h-[calc(100dvh-78px)] lg:min-h-[780px] lg:px-8">
        {/* Header Text Area */}
        <div className="mb-6 grid gap-6 text-white md:mb-8 lg:grid-cols-[minmax(0,1fr)_360px] lg:items-end lg:px-2">
          <div className="max-w-4xl">
          <span className="mb-4 inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/20 px-4 py-1.5 text-xs font-black uppercase tracking-[0.2em] text-white shadow-sm backdrop-blur-md">
            <FaPlaneDeparture className="h-3 w-3" /> Premium Flight Booking
          </span>
          <h1 className="mt-2 max-w-4xl text-4xl font-black leading-[1.05] tracking-tight drop-shadow-md sm:text-5xl md:text-6xl lg:text-7xl">
            Fly smarter with fares built around your trip.
          </h1>
          <p className="mt-4 max-w-2xl text-base font-medium leading-7 text-white/90 drop-shadow-sm sm:text-lg">
            Compare flexible routes, plan with confidence, and get live travel
            support from search to booking.
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            {popularRoutes.map((route) => (
              <span
                key={route}
                className="rounded-full border border-white/25 bg-white/15 px-4 py-2 text-xs font-black text-white shadow-sm backdrop-blur-md"
              >
                {route}
              </span>
            ))}
          </div>
          </div>

          <div className="hidden rounded-[1.5rem] border border-white/25 bg-white/15 p-4 shadow-[0_24px_70px_rgba(0,0,0,0.18)] backdrop-blur-xl lg:block">
            <div className="flex items-center gap-3 border-b border-white/15 pb-4">
              <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-white text-[#2871d3]">
                <FaShieldAlt />
              </div>
              <div>
                <div className="text-sm font-black">Trusted booking support</div>
                <div className="text-xs font-semibold text-white/70">
                  Transparent options before you choose
                </div>
              </div>
            </div>
            <div className="mt-4 grid grid-cols-3 gap-3">
              {trustStats.map(([value, label]) => (
                <div key={label} className="rounded-2xl bg-white/15 p-3">
                  <div className="text-lg font-black">{value}</div>
                  <div className="mt-1 text-[0.68rem] font-bold uppercase text-white/70">
                    {label}
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-4 flex items-center gap-2 rounded-2xl bg-emerald-400/15 px-4 py-3 text-sm font-black text-emerald-50">
              <FaStar className="text-amber-300" />
              Fast fare comparison with human help
            </div>
          </div>
        </div>

        {/* Search Widget Container - Glassmorphism */}
        <div className="rounded-[1.35rem] border border-white/50 bg-white/70 p-3 shadow-[0_30px_80px_rgba(0,0,0,0.16)] backdrop-blur-2xl sm:rounded-[2rem] sm:p-5 lg:p-6">
          {/* Top Controls (Trip Type & Direct Flights) */}
          <div className="mb-4 flex flex-col gap-3 sm:mb-6 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex w-full rounded-full bg-white/80 p-1 shadow-inner sm:w-auto">
              {[
                { label: "Return", value: "return" },
                { label: "One-way", value: "oneway" },
              ].map((item) => (
                <button
                  key={item.value}
                  type="button"
                  onClick={() => setTripType(item.value)}
                  className={`flex-1 sm:flex-none min-h-[44px] rounded-full px-6 text-sm font-bold transition-all duration-300 ${
                    tripType === item.value
                      ? "bg-[#2871d3] text-white shadow-md shadow-blue-600/25"
                      : "text-slate-600 hover:text-slate-900 hover:bg-slate-100/50"
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </div>

            <label className="group flex min-h-[44px] cursor-pointer items-center justify-between gap-3 rounded-full border border-white/60 bg-white/80 px-5 text-sm font-bold text-slate-700 shadow-sm transition-all hover:bg-white hover:text-slate-900 sm:justify-start">
              <span>Direct flights only</span>
              <span className="relative flex h-5 w-5 shrink-0 items-center justify-center">
                <input
                  type="checkbox"
                  checked={directOnly}
                  onChange={(e) => setDirectOnly(e.target.checked)}
                  className="peer h-5 w-5 cursor-pointer appearance-none rounded-[0.4rem] border-2 border-slate-300 bg-white/50 transition-all checked:border-[#2871d3] checked:bg-[#2871d3] focus:outline-none focus:ring-4 focus:ring-[#2871d3]/20"
                />
                <FaCheck className="pointer-events-none absolute h-2.5 w-2.5 text-white opacity-0 transition-opacity peer-checked:opacity-100" />
              </span>
            </label>
          </div>

          {/* Input Fields Grid */}
          <div className="grid grid-cols-1 gap-3 lg:grid-cols-12 lg:gap-4">
            {/* Origin & Destination Container */}
            <div className="relative flex flex-col gap-2 sm:grid sm:grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] lg:col-span-6 lg:gap-3">
              {/* Origin */}
              <div className="relative w-full" ref={originRef}>
                <div className={fieldShell}>
                  <label className={fieldLabel}>
                    <FaPlaneDeparture className="text-[#2871d3]" /> Leaving From
                  </label>
                  <input
                    type="text"
                    value={originQuery}
                    onChange={(e) => setOriginQuery(e.target.value)}
                    onFocus={() => setShowOriginDropdown(true)}
                    placeholder="City or Airport"
                    className={`${inputClass} truncate`}
                  />
                </div>
                <PlaceDropdown
                  show={showOriginDropdown}
                  results={originResults}
                  loading={loadingOrigin}
                  isOrigin
                />
              </div>

              {/* Swap Button (Now visible and absolute on mobile, inline on desktop) */}
              <div className="absolute left-1/2 top-1/2 z-20 flex h-10 w-10 -translate-x-1/2 -translate-y-1/2 items-center justify-center sm:static sm:h-auto sm:w-auto sm:translate-x-0 sm:translate-y-0">
                <button
                  type="button"
                  onClick={handleSwap}
                  aria-label="Swap origin and destination"
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-slate-100 bg-white text-[#2871d3] shadow-lg shadow-slate-900/10 transition-transform hover:scale-110 hover:bg-blue-50 active:scale-95 sm:h-11 sm:w-11"
                >
                  <FaExchangeAlt className="h-4 w-4 rotate-90 sm:rotate-0" />
                </button>
              </div>

              {/* Destination */}
              <div className="relative w-full" ref={destRef}>
                <div className={fieldShell}>
                  <label className={fieldLabel}>
                    <FaPlaneArrival className="text-[#2871d3]" /> Going To
                  </label>
                  <input
                    type="text"
                    value={destQuery}
                    onChange={(e) => setDestQuery(e.target.value)}
                    onFocus={() => setShowDestDropdown(true)}
                    placeholder="City or Airport"
                    className={`${inputClass} truncate`}
                  />
                </div>
                <PlaceDropdown
                  show={showDestDropdown}
                  results={destResults}
                  loading={loadingDest}
                  isOrigin={false}
                />
              </div>
            </div>

            {/* Dates Container */}
            <div className="grid grid-cols-2 gap-2 sm:gap-3 lg:col-span-3 lg:gap-4">
              <div className={fieldShell}>
                <label className={fieldLabel}>
                  <FaCalendarAlt className="text-[#2871d3]" /> Depart
                </label>
                <input
                  type="date"
                  min={todayStr}
                  value={departDate}
                  onChange={handleDepartDateChange}
                  className="w-full bg-transparent text-sm sm:text-base font-extrabold text-slate-900 outline-none [color-scheme:light]"
                />
              </div>

              <div
                className={`${fieldShell} ${
                  tripType === "oneway"
                    ? "opacity-50 pointer-events-none grayscale bg-white/40"
                    : ""
                }`}
              >
                <label className={fieldLabel}>
                  <FaCalendarAlt className="text-[#2871d3]" /> Return
                </label>
                <input
                  type="date"
                  min={departDate}
                  disabled={tripType === "oneway"}
                  value={tripType === "oneway" ? "" : returnDate}
                  onChange={(e) => setReturnDate(e.target.value)}
                  className="w-full bg-transparent text-sm sm:text-base font-extrabold text-slate-900 outline-none disabled:cursor-not-allowed [color-scheme:light]"
                />
              </div>
            </div>

            {/* Class & Search Button Container */}
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-[minmax(0,1fr)_auto] lg:col-span-3 lg:gap-4">
              <div className={fieldShell}>
                <label className={fieldLabel}>
                  <FaChevronDown className="text-[#2871d3]" /> Class
                </label>
                <select
                  value={cabinClass}
                  onChange={(e) => setCabinClass(e.target.value)}
                  className="w-full min-w-0 appearance-none truncate bg-transparent text-base font-extrabold text-slate-900 outline-none cursor-pointer"
                >
                  <option value="economy">Economy</option>
                  <option value="premium_economy">Premium Econ</option>
                  <option value="business">Business</option>
                  <option value="first">First Class</option>
                </select>
              </div>

              <button
                type="button"
                onClick={handleSearchFlights}
                className="group flex min-h-[60px] lg:min-h-[76px] w-full items-center justify-center gap-3 rounded-2xl md:rounded-[1.25rem] bg-[#2871d3] px-6 text-base lg:text-lg font-black text-white shadow-xl shadow-blue-600/20 transition-all duration-300 ease-out hover:-translate-y-1 hover:bg-[#1d5ab3] hover:shadow-2xl hover:shadow-blue-600/30 active:translate-y-0 sm:min-w-[140px]"
              >
                <FaSearch className="h-4 w-4 lg:h-5 lg:w-5 transition-transform duration-300 group-hover:scale-110" />
                <span>Search</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FlightSearchWidget;
